import Div from "components/primitives/Div";
import useResizeLayoutEffect from "hooks/useResizeLayoutEffect";
import { useCallback, useRef, useState } from "react";
import ParentDimensionsContext from "components/charting/contexts/ParentDimensionsContext";

interface RefParentDimensionsProviderProps {
  children?: React.ReactElement;
}

function RefBasedDimensionsProvider(props: RefParentDimensionsProviderProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState<{ width: number; height: number } | null>({ width: 0, height: 0 });

  const onResize = useCallback(() => {
    if (ref.current) {
      const { width, height } = ref.current.getBoundingClientRect();
      setDimensions({ width, height });
    }
  }, []);
  useResizeLayoutEffect(onResize, true);

  return (
    <Div ref={ref} sx={{ width: "100%", height: "100%" }}>
      {dimensions && (
        <ParentDimensionsContext.Provider value={dimensions}>{props.children}</ParentDimensionsContext.Provider>
      )}
    </Div>
  );
}
export default RefBasedDimensionsProvider;
